import { Box, Button } from "@mui/material";

export default function ErrorFileType({onClick}) {
  const click = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.4)",
        zIndex: 3000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          backgroundColor: "#fff3cd",
          color: "#856404",
          border: "2px solid #ffeeba",
          padding: "1rem 2rem",
          borderRadius: "8px",
          fontSize: "1.2rem",
          fontFamily: "Anek Latin",
          fontWeight: "bold",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h2 style={{marginBottom: "1px", marginTop: "0.5px"}}>⚠️ Invalid File Type</h2>
        <span>Please use one of the following formats:</span>
        <span>.png, .jpeg, .jpg, .svg, .bmp, .tiff</span>
        <Button
          onClick={click}
          variant="contained"
          sx={{
            mt: 2,
            backgroundColor: "#856404",
            color: "#fff3cd",
            "&:hover": {
              backgroundColor: "#6c4d03",
            },
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}
